var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReportePorUnidadGestion"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "grey lighten-2 text--info py-0" },
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    "align-center": "",
                    "justify-space-between": "",
                    row: "",
                    wrap: ""
                  }
                },
                [
                  _c("v-flex", { attrs: { shrink: "" } }, [
                    _c(
                      "h3",
                      { staticClass: "primary--text" },
                      [
                        _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("home")
                        ]),
                        _vm._v(" Listado de dependencias\n          ")
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { shrink: "" } }, [
                    _c("h3", { staticClass: "primary--text" }, [
                      _vm._v(
                        "\n            Gestión: " +
                          _vm._s(this.$route.params.gestion) +
                          "\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "px-3 py-0", attrs: { xs12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            color: "primary",
                            to: "/vacaciones-gestion-RRHH"
                          }
                        },
                        [_c("v-icon", [_vm._v("arrow_back")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("strong", [_vm._v(" LISTADO DE GESTIONES")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("crud-table", {
                staticClass: "tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  url: _vm.url,
                  filters: _vm.filters,
                  "data-graphql": _vm.dataGraphql,
                  graphql: _vm.graphql,
                  initData: _vm.initData
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.nombre_unidad) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "info",
                                  to:
                                    "/listado-funcionarios-RRHH-vacaciones/" +
                                    _vm.$util.encodeString(
                                      _vm.$route.params.gestion
                                    ) +
                                    "/" +
                                    _vm.$util.encodeString(
                                      items.item.nro_item
                                    ) +
                                    "/" +
                                    _vm.$util.encodeString(
                                      items.item.id_unidad
                                    ) +
                                    "/" +
                                    _vm.$util.encodeString(items.item.case) +
                                    "/" +
                                    _vm.$util.encodeString(
                                      items.item.id_persona
                                    ),
                                  icon: "",
                                  title: "Ver programaciones de vacación"
                                }
                              },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "warning",
                                  icon: "",
                                  dark: "",
                                  title: "Ver reporte de vacación"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.verReportePorUnidadGestion(
                                      items.item,
                                      1
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("picture_as_pdf")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  dark: "",
                                  color: "#44deaa",
                                  icon: "",
                                  title:
                                    "Aprobar programación de vacación de la dependencia"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.aprobarProgramacionDependenciaRRHH(
                                      items.item
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("done")])],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8c8bfce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8c8bfce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/VacacionesListadoUnidades.vue
// module id = null
// module chunks = 